<template>
  <div>
    <h4 class="mb-4 text-utel"><strong>Listado de administradores</strong></h4>
    
    <v-data-table
      :headers="headers" 
      :items="users" 
      item-key="id" 
      :page="currentPage"
      :items-per-page="itemsPerPage" 
      class="elevation-1 table text-center align-middle small" 
      :loading="loading"
      loading-text="Cargando..." 
      mobile-breakpoint="0" 
      :header-props="{ sortIcon: 'fa-solid fa-up-down' }"
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr class="text-center">
          <td>{{ item.id }}</td>
          <td>{{ item.firstname }} {{ item.lastname }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.role }}</td>
          <td>{{ item.empresa?.name ?? item.client?.name ?? "" }}</td>
          <td>
            <span :class="getStatusClass(item.status)">
              {{ getStatusText(item.status) }}
            </span>
          </td>
          <td>
            <div class="fw-bold text-center small" style="width: 80px">
              {{ item.created_at_convert || "" }}
            </div>
          </td>
          <td>
            <button 
              type="button" 
              class="btn bg-utel-v2-secondary p-2 m-1 px-3 rounded-pill text-primary me-1" 
              title="Editar usuario" 
              @click="$emit('edit-user', item)"
            >
              <i class="fa-solid fa-edit"></i>
            </button>
            <button 
              type="button" 
              class="btn bg-utel-v2-secondary p-2 m-1 px-3 rounded-pill text-primary" 
              title="Eliminar usuario" 
              @click="$emit('delete-user', item)"
            >
              <i class="fa-solid fa-trash"></i>
            </button>
          </td>
        </tr>
      </template>
    </v-data-table>

    <simple-pagination 
      :current-page="currentPage"
      :page-count="pageCount"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import SimplePagination from './SimplePagination.vue'

export default {
  name: 'UserTable',
  
  components: {
    SimplePagination
  },
  
  props: {
    users: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    currentPage: { type: Number, default: 1 },
    pageCount: { type: Number, default: 1 },
    itemsPerPage: { type: Number, default: 10 },
    clients: { type: Array, default: () => [] },
    token: { type: String, default: '' },
    get: { type: String, default: '' },
    rol: { type: [String, Object, Array], default: '' },
    urlvalidateemail: { type: String, required: true },
    issuperadmin: { type: Boolean, default: false },
    headertab: { type: Array, default: () => [] },
    download: { type: String, default: '' },
    filters: { type: Object, default: () => ({}) }
  },
  
  emits: ['edit-user', 'delete-user', 'page-change', 'reload-table'],
  
  computed: {
    headers() {
      return [
        { text: "#", value: "id", align: 'center' },
        { text: "Nombre", value: "firstname", align: 'center' },
        { text: "Correo", value: "email", align: 'center' },
        { text: "Rol", value: "rol", align: 'center' },
        { text: "Cliente", value: "client_id", align: 'center' },
        { text: "Estado", value: "status", align: 'center' },
        { text: "Registrado desde", value: "created_at_convert", align: 'center' },
        { text: "Opciones", value: "actions", sortable: false }
      ]
    },
    
    // Convertir rol a string si es necesario
    rolString() {
      if (typeof this.rol === 'string') return this.rol;
      if (Array.isArray(this.rol) && this.rol.length > 0) {
        const firstRole = this.rol[0];
        return firstRole.name || firstRole.rol || firstRole.role || '';
      }
      if (typeof this.rol === 'object' && this.rol !== null) {
        return this.rol.name || this.rol.rol || this.rol.role || '';
      }
      return String(this.rol || '');
    }
  },
  
  mounted() {
    console.log('UserTable mounted - currentPage:', this.currentPage, 'pageCount:', this.pageCount);
  },
  
  methods: {
    getClientName(clientId) {
      const client = this.clients.find(c => c.id === clientId)
      return client ? client.name : 'N/A'
    },
    
    handlePageChange(page) {
      this.$emit('page-change', page);
    },
    
    getStatusClass(status) {
      return {
        'badge bg-success': status === 'active',
        'badge bg-danger': status === 'inactive',
        'badge bg-warning': status === 'pending'
      }
    },
    
    getStatusText(status) {
      const statusMap = {
        'active': 'Activo',
        'inactive': 'Inactivo', 
        'pending': 'Pendiente'
      }
      return statusMap[status] || status
    }
  }
}
</script>

<style scoped>
.text-utel {
  color: #1A0054;
}

.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
</style>